import { Injectable } from '@angular/core';
import { createSelector } from '@ngrx/store';
import { SafariReduxPageUiObject, defaultPageUiState, PageUiState } from '@safarilaw-webapp/shared/redux';
import { getSharedFeatureState } from './state.selector';

@Injectable({ providedIn: 'root' })
export class LpmsDefaultPageReduxUiObject extends SafariReduxPageUiObject<PageUiState> {
  default = {};

  constructor() {
    const getPageState = createSelector(getSharedFeatureState, state => state.pages.defaultPageState);
    super('Lpms', 'Default Page', getPageState, defaultPageUiState);
  }
}
